/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1TransfersScheduleEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_TRANSFERS_SCHEDULE_EVENT_ENTITY_NAME = 'ixf.hours.v1.TransfersScheduleEvent';
export const ixfHoursV1TransfersScheduleEventEntity = new schema.Entity<IxfHoursV1TransfersScheduleEvent>(IXF_HOURS_V1_TRANSFERS_SCHEDULE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfHoursV1TransfersScheduleEvent) => `${entity.metadata?.eventId}` });

